import { useMutation } from '@tanstack/react-query';

import type { MutationResponse } from '@/types/api/mutations';

import { HttpClient } from '@/network/HttpClient';

export const useRevertClientUsageMutation = () =>
  useMutation({
    mutationFn: (url: string) =>
      HttpClient.request<MutationResponse>({
        method: 'POST',
        url,
      }),
  });
